<template>
  <fieldset class="slds-form-element" :class="{'slds-has-error': !valid}">
    <legend class="slds-form-element__legend slds-form-element__label" v-if="!noLabel">{{label}}</legend>
    <div class="slds-form-element__control">
      <span class="slds-radio" v-for="(option, index) in options" :key="index" :class="{ 'horizontal' : horizontal }">
        <input :ref="`radioOption_${index}`" type="radio" :id="`radio-${id}-${index}`" :value="option.value" :name="`radio-${id}-value`" v-model="localValue" :disabled="disabled" :checked="option.value === localValue" />
        <label class="slds-radio__label" :for="`radio-${id}-${index}`" :class="{'cursor-pointer': !disabled}">
          <span class="slds-radio_faux"></span>
          <span class="slds-form-element__label">{{option.label}}</span>
          <div class="option-description" v-if="option.description">{{option.description}}</div>
        </label>
      </span>
    </div>

    <div class="slds-form-element__help error" v-if="!valid">{{error}}</div>

  </fieldset>
</template>
<script>
import Validator from '../../validation/Validator'
export default {
  mixins: [Validator],
  props: {
    disabled: Boolean,
    horizontal: Boolean,
    label: String,
    options: Array,
    noLabel: Boolean,
    value: String
  },
  created () {
    this.localValue = this.value
  },
  data () {
    return {
      id: parseInt(Math.random() * 1000),
      localValue: ''
    }
  },
  methods: {
    focus () {
      if (this.$refs.radioOption_0) {
        this.$refs.radioOption_0[0].focus()
      }
    }
  },
  watch: {
    localValue (value, oldValue) {
      this.$emit('input', value)
      if (!!oldValue && oldValue.length > 0 && JSON.stringify(value) !== JSON.stringify(oldValue)) {
        this.$emit('change', value)
      }
    },
    value (value) {
      this.localValue = value
      this.clearValidationError()
    }
  }
}
</script>
<style lang="scss" scoped>
  .cursor-pointer {
    cursor: pointer;
  }
  .error {
    color: #C23933;
  }
  .option-description {
    float: left;
    width: calc(100% - 2.3rem);
    overflow-wrap: break-word;
    word-wrap: break-word;
  }
  .horizontal {
    display: inline !important;
  }
</style>
